import React, { useRef, useCallback } from "react";
import { useViewport } from 'components/general/useViewPort'
import { useParams } from "react-router-dom"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faLocationDot,
} from "@fortawesome/free-solid-svg-icons";


// Import Swiper React components
import { useSwiper } from 'swiper/react';
//import SwiperCore, { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, A11y } from "swiper";

// Import Swiper styles
import 'swiper/css';



const MyComponent = () => {
    const sliderRef = useRef(null);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    return (
        <div>
            <Swiper ref={sliderRef}>
                <SwiperSlide>slide 1</SwiperSlide>
                <SwiperSlide>slide 2</SwiperSlide>
            </Swiper>
            <div className="prev-arrow" onClick={handlePrev} >Prev</div>
            <div className="next-arrow" onClick={handleNext} >Next</div>
        </div>
    )
}


const Test = () => {

    const sliderRef = useRef(null);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);


    return (
        <>
            <div className="d-flex">
                <div className="prev-arrow" onClick={handlePrev} >Prev</div>
                <Swiper className="wrs-action-line" ref={sliderRef}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    // navigation={true}
                    pagination={{ clickable: true, }}
                    modules={[Pagination, Navigation, A11y]}
                //slidesPerView={1}
                //observer={true}
                >
                    <SwiperSlide className="period">

                        <div className="s-timeline-container">
                            <div className="s-timeline-bar">
                                <div className="s-circle is-started">1</div>

                                <div className="s-bar">
                                    <div className="s-progress" style={{ width: "100%" }}></div>
                                </div>
                            </div>


                            <div className="s-events s-events--team1">
                                <div className="s-event" style={{ left: "0%" }}><span style={{ position: 'absolute', bottom: "-15px" }}>0 </span><FontAwesomeIcon className='s-event-type-icon' icon={faLocationDot} />
                                    {/** 
                            <div className="s-dropdown" style="padding: 5px 8px;">
                                <div className="s-time s-time--single">26:21</div>
                                <div className="s-team" style="background-color: rgb(21, 149, 211);"></div>
                                <div className="s-description"><span class="s-info">2m</span> <span><span class="s-title">#22 GALIEV Stanislav</span></span></div>
                            </div>
                            */}
                                </div>
                                <div className="s-event" style={{ left: "40%" }}><span style={{ position: 'absolute', bottom: "-15px" }}>40 </span><FontAwesomeIcon className='s-event-type-icon' icon={faLocationDot} />
                                </div>

                            </div>

                            <div className="s-events s-events--team2">

                                <div className="s-event" style={{ left: "100%" }}><FontAwesomeIcon className='s-event-type-icon' icon={faLocationDot} />
                                    {/** 
                            <div className="s-dropdown" style="padding: 5px 8px;">
                                <div className="s-time s-time--single">26:21</div>
                                <div className="s-team" style="background-color: rgb(21, 149, 211);"></div>
                                <div className="s-description"><span class="s-info">2m</span> <span><span class="s-title">#22 GALIEV Stanislav</span></span></div>
                            </div>
                            */}
                                </div>

                            </div>
                        </div>


                    </SwiperSlide>

                    <SwiperSlide className="period">
                        <div className="s-timeline-container">
                            <div className="s-timeline-bar">
                                <div className="s-circle is-started">2</div>

                                <div className="s-bar">
                                    <div className="s-progress" style={{ width: "100%" }}></div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>


                    <SwiperSlide className="period" style={{ width: "50%", color: "red" }}>
                        <div className="s-timeline-container">
                            <div className="s-timeline-bar">
                                <div className="s-circle is-started">50</div>

                                <div className="s-bar">
                                    <div className="s-progress" style={{ width: "100%" }}></div>
                                </div>
                            </div>
                        </div>

                    </SwiperSlide>

                    <SwiperSlide className="period" style={{ width: "70%", color: "red" }}>
                        <div className="s-timeline-container">
                            <div className="s-timeline-bar">
                                <div className="s-circle is-started">70</div>

                                <div className="s-bar">
                                    <div className="s-progress" style={{ width: "100%" }}></div>
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>

                    <SwiperSlide className="period" style={{ width: "50%", color: "red" }}>
                        <div className="s-timeline-container">
                            <div className="s-timeline-bar">
                                <div className="s-circle is-started">50</div>

                                <div className="s-bar">
                                    <div className="s-progress" style={{ width: "100%" }}></div>
                                </div>


                                <div className="s-events s-events--team1">
                                    <div className="s-event" style={{ left: "30%" }}><span style={{ position: 'absolute', bottom: "-15px" }}>30 </span><FontAwesomeIcon className='s-event-type-icon' icon={faLocationDot} />

                                    </div>
                                    <div className="s-event" style={{ left: "40%" }}><span style={{ position: 'absolute', bottom: "-15px" }}>40 </span><FontAwesomeIcon className='s-event-type-icon' icon={faLocationDot} />
                                    </div>

                                </div>

                                <div className="s-events s-events--team2">

                                    <div className="s-event" style={{ left: "100%" }}><FontAwesomeIcon className='s-event-type-icon' icon={faLocationDot} />

                                    </div>

                                </div>

                            </div>
                        </div>

                    </SwiperSlide>
                </Swiper>

                <div className="next-arrow" onClick={handleNext} >Next</div>
            </div>
        </>
    );
};


export default Test

